import React from 'react';
import { Link } from 'react-router-dom';
import { createUseStyles } from 'react-jss';
import { Theme } from '@app/theme';

interface Props {
  className?: string;
}

const useStyles = createUseStyles((theme: Theme) => ({
  logo: {
    marginBottom: theme.marginBase * 2,
    ...theme.flexCenter,

    width: theme.height.small,
    height: theme.height.small,

    borderRadius: '50%',
    [theme.media.largeScreen]: {
      display: 'none',
    },
    backgroundColor: theme.colors.red,
    color: theme.colors.white,
    '& > i': {
      fontSize: theme.iconSize.large,
    },
  },
}));

export const TandemzLogoHeader = ({ className }: Props) => {
  const classes = useStyles();
  return (
    <Link to="/" className={classes.logo}>
      <i className="custom-icon-font-tandemz" title="Logo" />
    </Link>
  );
};
